import ApiService from './api'
import qs from 'qs';

const AdminService = {
    getSubscribers: async function(){
        const data = {
            PageSize:100000,
            PageNumber: 1,
            OrderBy: "ID DESC"
        }
        const query = `${process.env.VUE_APP_ROOT_API_ENV}/dashboard/listsubscribers`;
        try{
            const response = await ApiService.post(query, qs.stringify(data));
            if(response.status){
                console.log('-- get subscribers ok --');
                return response.data;
            }
            console.warn('!! error get subscribers ', response);
            return false;
        } catch (error){
            console.warn('!! error get subscribers ', error);
            return false;
        }
    },
    deleteSubscriber: async function(data){
        const query = `${process.env.VUE_APP_ROOT_API_ENV}/dashboard/delsubscriber`;
        try{
            const response = await ApiService.post(query, qs.stringify(data));
            if(response.status){
                console.log('-- delete subscriber ok --');
                return response.data;
            }
            console.warn('!! error delete subscribers ', response);
            return false;
        } catch (error){
            console.warn('!! error delete subscribers ', error);
            return false;
        }
    }
}

export default AdminService;